import { type ComponentsOverrides } from '@mui/material/styles'

import { Z_INDEX_HEADER } from '@Styles/constants/layout'

export const overridesDrawer = (): ComponentsOverrides['MuiDrawer'] => ({
  root: {
    zIndex: Z_INDEX_HEADER + 1,
  },
})
